// source: v2/types/teams.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.loopup.ctgateway.v2.TeamsApiAccessStatus', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.TeamsConnection', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.TeamsOperatorConnectConsentStatus', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.TeamsSyncStatus', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.TeamsUserTokenCache', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.TeamsUserTokenStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.TeamsConnection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.TeamsConnection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.TeamsConnection.displayName = 'proto.loopup.ctgateway.v2.TeamsConnection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.TeamsUserTokenCache, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.TeamsUserTokenCache.displayName = 'proto.loopup.ctgateway.v2.TeamsUserTokenCache';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.displayName = 'proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.TeamsConnection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.TeamsConnection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.TeamsConnection.toObject = function(includeInstance, msg) {
  var f, obj = {
    tenantId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    syncStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    lastSynchronizedTime: (f = msg.getLastSynchronizedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    currentSyncStartTime: (f = msg.getCurrentSyncStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    lastSynchronizationFailureTime: (f = msg.getLastSynchronizationFailureTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    userTokenCache: (f = msg.getUserTokenCache()) && proto.loopup.ctgateway.v2.TeamsUserTokenCache.toObject(includeInstance, f),
    syncWithTenantAccessToken: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    apiAccessStatus: jspb.Message.getFieldWithDefault(msg, 8, 0),
    operatorConnectStatus: (f = msg.getOperatorConnectStatus()) && proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection}
 */
proto.loopup.ctgateway.v2.TeamsConnection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.TeamsConnection;
  return proto.loopup.ctgateway.v2.TeamsConnection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.TeamsConnection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection}
 */
proto.loopup.ctgateway.v2.TeamsConnection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    case 2:
      var value = /** @type {!proto.loopup.ctgateway.v2.TeamsSyncStatus} */ (reader.readEnum());
      msg.setSyncStatus(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastSynchronizedTime(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCurrentSyncStartTime(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastSynchronizationFailureTime(value);
      break;
    case 6:
      var value = new proto.loopup.ctgateway.v2.TeamsUserTokenCache;
      reader.readMessage(value,proto.loopup.ctgateway.v2.TeamsUserTokenCache.deserializeBinaryFromReader);
      msg.setUserTokenCache(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSyncWithTenantAccessToken(value);
      break;
    case 8:
      var value = /** @type {!proto.loopup.ctgateway.v2.TeamsApiAccessStatus} */ (reader.readEnum());
      msg.setApiAccessStatus(value);
      break;
    case 9:
      var value = new proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus;
      reader.readMessage(value,proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.deserializeBinaryFromReader);
      msg.setOperatorConnectStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.TeamsConnection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.TeamsConnection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.TeamsConnection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSyncStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getLastSynchronizedTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCurrentSyncStartTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastSynchronizationFailureTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUserTokenCache();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.loopup.ctgateway.v2.TeamsUserTokenCache.serializeBinaryToWriter
    );
  }
  f = message.getSyncWithTenantAccessToken();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getApiAccessStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getOperatorConnectStatus();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TeamsSyncStatus sync_status = 2;
 * @return {!proto.loopup.ctgateway.v2.TeamsSyncStatus}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.getSyncStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.TeamsSyncStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.TeamsSyncStatus} value
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.setSyncStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp last_synchronized_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.getLastSynchronizedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
*/
proto.loopup.ctgateway.v2.TeamsConnection.prototype.setLastSynchronizedTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.clearLastSynchronizedTime = function() {
  return this.setLastSynchronizedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.hasLastSynchronizedTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp current_sync_start_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.getCurrentSyncStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
*/
proto.loopup.ctgateway.v2.TeamsConnection.prototype.setCurrentSyncStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.clearCurrentSyncStartTime = function() {
  return this.setCurrentSyncStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.hasCurrentSyncStartTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp last_synchronization_failure_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.getLastSynchronizationFailureTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
*/
proto.loopup.ctgateway.v2.TeamsConnection.prototype.setLastSynchronizationFailureTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.clearLastSynchronizationFailureTime = function() {
  return this.setLastSynchronizationFailureTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.hasLastSynchronizationFailureTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional TeamsUserTokenCache user_token_cache = 6;
 * @return {?proto.loopup.ctgateway.v2.TeamsUserTokenCache}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.getUserTokenCache = function() {
  return /** @type{?proto.loopup.ctgateway.v2.TeamsUserTokenCache} */ (
    jspb.Message.getWrapperField(this, proto.loopup.ctgateway.v2.TeamsUserTokenCache, 6));
};


/**
 * @param {?proto.loopup.ctgateway.v2.TeamsUserTokenCache|undefined} value
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
*/
proto.loopup.ctgateway.v2.TeamsConnection.prototype.setUserTokenCache = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.clearUserTokenCache = function() {
  return this.setUserTokenCache(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.hasUserTokenCache = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool sync_with_tenant_access_token = 7;
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.getSyncWithTenantAccessToken = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.setSyncWithTenantAccessToken = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional TeamsApiAccessStatus api_access_status = 8;
 * @return {!proto.loopup.ctgateway.v2.TeamsApiAccessStatus}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.getApiAccessStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.TeamsApiAccessStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.TeamsApiAccessStatus} value
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.setApiAccessStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional TeamsOperatorConnectStatus operator_connect_status = 9;
 * @return {?proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.getOperatorConnectStatus = function() {
  return /** @type{?proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus} */ (
    jspb.Message.getWrapperField(this, proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus, 9));
};


/**
 * @param {?proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus|undefined} value
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
*/
proto.loopup.ctgateway.v2.TeamsConnection.prototype.setOperatorConnectStatus = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.TeamsConnection} returns this
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.clearOperatorConnectStatus = function() {
  return this.setOperatorConnectStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.TeamsConnection.prototype.hasOperatorConnectStatus = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.TeamsUserTokenCache.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.TeamsUserTokenCache} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.toObject = function(includeInstance, msg) {
  var f, obj = {
    createdTime: (f = msg.getCreatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    tokenStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    lastUsedValidTime: (f = msg.getLastUsedValidTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    lastUsedInvalidTime: (f = msg.getLastUsedInvalidTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    lastInteractiveLoginTime: (f = msg.getLastInteractiveLoginTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.TeamsUserTokenCache}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.TeamsUserTokenCache;
  return proto.loopup.ctgateway.v2.TeamsUserTokenCache.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.TeamsUserTokenCache} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.TeamsUserTokenCache}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedTime(value);
      break;
    case 2:
      var value = /** @type {!proto.loopup.ctgateway.v2.TeamsUserTokenStatus} */ (reader.readEnum());
      msg.setTokenStatus(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUsedValidTime(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUsedInvalidTime(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastInteractiveLoginTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.TeamsUserTokenCache.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.TeamsUserTokenCache} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreatedTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTokenStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getLastUsedValidTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastUsedInvalidTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastInteractiveLoginTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp created_time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.getCreatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.TeamsUserTokenCache} returns this
*/
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.setCreatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.TeamsUserTokenCache} returns this
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.clearCreatedTime = function() {
  return this.setCreatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.hasCreatedTime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TeamsUserTokenStatus token_status = 2;
 * @return {!proto.loopup.ctgateway.v2.TeamsUserTokenStatus}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.getTokenStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.TeamsUserTokenStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.TeamsUserTokenStatus} value
 * @return {!proto.loopup.ctgateway.v2.TeamsUserTokenCache} returns this
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.setTokenStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp last_used_valid_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.getLastUsedValidTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.TeamsUserTokenCache} returns this
*/
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.setLastUsedValidTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.TeamsUserTokenCache} returns this
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.clearLastUsedValidTime = function() {
  return this.setLastUsedValidTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.hasLastUsedValidTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp last_used_invalid_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.getLastUsedInvalidTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.TeamsUserTokenCache} returns this
*/
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.setLastUsedInvalidTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.TeamsUserTokenCache} returns this
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.clearLastUsedInvalidTime = function() {
  return this.setLastUsedInvalidTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.hasLastUsedInvalidTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp last_interactive_login_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.getLastInteractiveLoginTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.TeamsUserTokenCache} returns this
*/
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.setLastInteractiveLoginTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.TeamsUserTokenCache} returns this
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.clearLastInteractiveLoginTime = function() {
  return this.setLastInteractiveLoginTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenCache.prototype.hasLastInteractiveLoginTime = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    consentStatus: jspb.Message.getFieldWithDefault(msg, 1, 0),
    consentedCountriesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus}
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus;
  return proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus}
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.loopup.ctgateway.v2.TeamsOperatorConnectConsentStatus} */ (reader.readEnum());
      msg.setConsentStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addConsentedCountries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConsentStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getConsentedCountriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional TeamsOperatorConnectConsentStatus consent_status = 1;
 * @return {!proto.loopup.ctgateway.v2.TeamsOperatorConnectConsentStatus}
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.prototype.getConsentStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.TeamsOperatorConnectConsentStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.TeamsOperatorConnectConsentStatus} value
 * @return {!proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus} returns this
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.prototype.setConsentStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated string consented_countries = 2;
 * @return {!Array<string>}
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.prototype.getConsentedCountriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus} returns this
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.prototype.setConsentedCountriesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus} returns this
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.prototype.addConsentedCountries = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus} returns this
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectStatus.prototype.clearConsentedCountriesList = function() {
  return this.setConsentedCountriesList([]);
};


/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.TeamsUserTokenStatus = {
  TEAMS_USER_TOKEN_STATUS_INVALID: 0,
  TEAMS_USER_TOKEN_STATUS_BROKEN: 1,
  TEAMS_USER_TOKEN_STATUS_OK: 2,
  TEAMS_USER_TOKEN_STATUS_NO_TOKEN: 3
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.TeamsSyncStatus = {
  TEAMS_SYNC_STATUS_INVALID: 0,
  TEAMS_SYNC_STATUS_DISABLED: 1,
  TEAMS_SYNC_STATUS_FAILED: 2,
  TEAMS_SYNC_STATUS_SUCCESSFUL: 3,
  TEAMS_SYNC_STATUS_SYNC_IN_PROGRESS: 4,
  TEAMS_SYNC_STATUS_NOT_YET_SYNCED: 5
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.TeamsApiAccessStatus = {
  TEAMS_API_ACCESS_STATUS_INVALID: 0,
  TEAMS_API_ACCESS_STATUS_NO_ACCESS: 1,
  TEAMS_API_ACCESS_STATUS_GRAPH_ONLY: 2,
  TEAMS_API_ACCESS_STATUS_VALID: 3
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.TeamsOperatorConnectConsentStatus = {
  TEAMS_OPERATOR_CONNECT_CONSENT_STATUS_INVALID: 0,
  TEAMS_OPERATOR_CONNECT_CONSENT_STATUS_NONE: 1,
  TEAMS_OPERATOR_CONNECT_CONSENT_STATUS_ACTIVE: 2,
  TEAMS_OPERATOR_CONNECT_CONSENT_STATUS_SUSPENDED: 3,
  TEAMS_OPERATOR_CONNECT_CONSENT_STATUS_REMOVED: 4
};

goog.object.extend(exports, proto.loopup.ctgateway.v2);
